/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type InternalChannel =
  typeof InternalChannel[keyof typeof InternalChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalChannel = {
  DIRECT: 'DIRECT',
  DISTRIBUTOR: 'DISTRIBUTOR',
  IFA: 'IFA',
} as const;
